import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_SubHeader.scss';
import { Button, ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { dispatch_onTriggerPanel } from '../../../dispatchers.js';
import { Dialog_ReferencablesGraph } from '../../../_entity/referencable/Dialog_ReferencablesGraph/Dialog_ReferencablesGraph.js';
export class Component_SubHeader extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return {};
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }
    render() {
        return (_jsxs(LL_H_C, { className: 'knowledge-manager__sub-header sub-header__status', children: [_jsx(LL_H_C, { style: { flexGrow: '1', justifyContent: 'space-between' }, children: this.props.children }), _jsx(Button, { onClick: () => Dialog_ReferencablesGraph.show(), children: "Referencables Graph" }), _jsx(Button, { onClick: () => dispatch_onTriggerPanel.dispatchUI(), children: "Toggle Conflicts Panel" }), this.props.cleanWorkspace && _jsx(ICONS.bin.component, { onClick: this.props.cleanWorkspace, className: 'delete-workspace' })] }));
    }
}
//# sourceMappingURL=Component_SubHeader.js.map